export default __webpack_public_path__ + "static/media/IoTGateway.f6a10891.svg";